module.exports = __webpack_public_path__ + "static/media/bglogin.6ad278a2.jpg";